import * as React from "react";
import { InstantCollapsible, MbnIcon } from "sb-resp-ui";
import { ContainerQuery } from "react-container-query";
import { CardType } from "../../../../data";
import { marketColumnsDisplayMultiview } from "../../../../constants";
import { MainHeading } from "../MainHeading";
import { GroupingDropdown } from "../GroupingDropdown";
import { HeadingNamesWrap } from "../HeadingNamesWrap";
import { HeadingTitle } from "../HeadingTitle";
import { ToggleOddsBtn } from "../ToggleOddsBtn";
export class MainContent extends React.PureComponent {
    renderGroupingDropdown() {
        return this.props.filterProps && this.props.filterProps.shouldShow &&
            React.createElement(GroupingDropdown, Object.assign({}, this.props.filterProps));
    }
    renderToggleButton() {
        return this.props.toggleOddsBtn && this.props.toggleOddsBtn.shouldShow &&
            React.createElement(ToggleOddsBtn, Object.assign({}, this.props.toggleOddsBtn));
    }
    renderMarketNames(params) {
        return this.props.marketNames.length > 0 &&
            React.createElement(HeadingNamesWrap, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params });
    }
    renderHeading(renderChildren, params) {
        return React.createElement(React.Fragment, null,
            React.createElement(MainHeading, { cardType: this.props.cardType },
                React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
                this.renderMarketNames(params),
                this.renderToggleButton(),
                this.renderGroupingDropdown(),
                this.props.mbnTag &&
                    React.createElement(MbnIcon, { tagNumber: this.props.mbnTag })),
            renderChildren && this.props.children);
    }
    renderHeadingWrapper(renderChildren) {
        return this.props.cardType === CardType.Multiview
            ? React.createElement(ContainerQuery, { query: marketColumnsDisplayMultiview }, (params) => this.renderHeading(renderChildren, params))
            : this.renderHeading(renderChildren);
    }
    render() {
        return React.createElement("div", { className: "rj-ev-list__content", "data-uat": "div-ev-list-content" }, this.props.shouldCollapse
            ? (React.createElement(InstantCollapsible, { initiallyExpanded: this.props.shouldExpand, trigger: this.renderHeadingWrapper(false), content: React.createElement(React.Fragment, null, this.props.children) }))
            : this.renderHeadingWrapper(true));
    }
}
//# sourceMappingURL=MainContent.js.map